import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import './styles/index.css';
import App from './App';

function Health() {
  return(<div><h3>East or West, SWA is the best</h3></div>)
}

try {
  ReactDOM.render(
    <React.StrictMode>
      <Router>
        <Switch>
          <Route exact path='/health' component={Health} />          
          {/* <Route exact path='/' component={App} /> */}
          <Route exact path="/(.*)" component={App}/>
            {/* <Redirect to="/" /> */}
          {/* </Route> */}
        </Switch>
      </Router>
    </React.StrictMode>,
    document.getElementById('root')
  );
} catch (error) {
}